module.exports = __webpack_public_path__ + "static/media/points10_5.1cfa80c8.png";